module.exports = __webpack_public_path__ + "static/product5-a-57f549f9205207cbccb3999edba43e24.pdf";